import React, { useEffect } from 'react';
import { useMap } from 'react-leaflet';
import { logger } from '../../lib/logger';
import { useAtom } from 'jotai';
import { locationPermissionAtom, locationErrorAtom } from '../../atoms/location';

interface MapControllerProps {
  onMapReady: (map: L.Map) => void;
}

export default function MapController({ onMapReady }: MapControllerProps) {
  const map = useMap();
  const [permissionStatus] = useAtom(locationPermissionAtom);
  const [locationError] = useAtom(locationErrorAtom);
  
  useEffect(() => {
    if (map) {
      try {
        // Make sure dragging is enabled regardless of location permission
        map.dragging.enable();
        map.touchZoom.enable();
        map.doubleClickZoom.enable();
        map.scrollWheelZoom.enable();
        
        // Ensure the map doesn't move after initialization unless the user moves it
        map.once('moveend', () => {
          // After initial movement, don't recenter automatically
          logger.info('Map initial position set', 'MapController');
        });
        
        onMapReady(map);
      } catch (error) {
        logger.error(error, 'map_controller');
      }
    }
  }, [map, onMapReady]);
  
  return null;
}